import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import MultiSelect from './MultiSelect';

const TopicFilter = ({ filter, selected = [], onChange }) => {
  const [value, setValue] = useState(selected.length ? selected : [[]]);

  const updateValue = newVal => {
    if (!newVal || newVal.length === 0) {
      newVal = [[]];
    }
    setValue(newVal);
    onChange(newVal);
  };


  const handleSelect = (andIndex, selectedOptions) => {
    const updated = [...value];
    updated[andIndex] = selectedOptions; 
    if (!selectedOptions || selectedOptions.length === 0) {
      updated.splice(andIndex, 1);
    }
    updateValue(updated);
  };

  const addAndGroup = selectedFromAdder => {
    if (value.length >= 2) return;
    const updated = [...value, selectedFromAdder && selectedFromAdder.length ? selectedFromAdder : []];
    updateValue(updated);
  };

  const removeAndGroup = andIndex => {
    const updated = [...value];
    updated.splice(andIndex, 1);
    updateValue(updated);
  };

  return (
    <View style={styles.container}>
      {value.map((andGroup, andIdx) => (
        <View key={`and-${andIdx}`} style={styles.andGroup}>
          <View style={styles.orRow}>
            <MultiSelect
              mode='multi'
              options={filter.options}
              selected={andGroup}
              onSelect={selectedOptions => handleSelect(andIdx, selectedOptions)}
              selectLabel='OR'
            />
          </View>

          {andIdx === 0 && <Text style={styles.andLabel}>AND</Text>}
        </View>
      ))}

      {value.length < 2 && (
        <MultiSelect
          mode='multi'
          options={filter.options}
          selected={[]}
          onSelect={selected => addAndGroup(selected)}
        />
      )}
    </View>
  );
};

export default TopicFilter;

const styles = StyleSheet.create({
  container: {
    padding: 10,
    marginVertical: 4
  },
  andGroup: {
    padding: 8,
    paddingVertical: 0,
    backgroundColor: '#fff',
    position: 'relative'
  },
  andLabel: {
    fontSize: 11,
    marginLeft: -11,
    fontWeight: '400',
    zIndex: 5,
    color: '#1b2438'
  },
  orRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 0,
    gap: 6,
    borderLeftWidth: 1,
    borderLeftColor: '#dde1e5',
    paddingLeft: 8
  }
});
